export default "__VITE_ASSET__DeGX$oZ$__"